import { AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http, RequestOptions ,Headers} from '@angular/http';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { GlobalServiceProvider } from './global-service';

@Injectable()
export class LoginServiceProvider {

    private mensagem: any;
    private url: string = '';
    private body: any;

    constructor(private http: Http, private alertCtrl: AlertController, public storage: Storage, public global: GlobalServiceProvider) {

    }

    fetchData(username: string, password: string, rest: string, options: RequestOptions, tenantId: string): Promise<any> {

        this.url = rest + '/moblogin';

        let alertctrl = this.alertCtrl.create({
            title: 'Falha no Login',
            subTitle: 'Falha no Login',
            buttons: ['Fechar']
        });

        return new Promise(resolve => {
            this.http.get(this.url, options).map(res => res.json()).subscribe(data => {
                this.mensagem = data

                console.log(this.mensagem)

                const branchValid: any = this.mensagem.data.usuario_empresas.find(
                    empresa => empresa.empresa_codigo + "," + empresa.filial_codigo === tenantId)
                
                if (!branchValid) {
                    alertctrl.setSubTitle("Usuário sem acesso a empresa ou filial");
                    alertctrl.present();
                } else {

                    let headers = new Headers({'Content-Type': 'application/json',"Accept": "application/json"});
                    let httpOptions = new RequestOptions({ headers: headers });

                    this.body = '{"data":{'
                    this.body += '"cnpj":"' + branchValid.filial_cnpj + '",'
                    this.body += '"produto":"MB"'
                    this.body += '}}';
                    this.global.setFullCompany(branchValid)
                    resolve(this.mensagem);

                    /*
                    this.http.post('https://webhook.app.hubhero.com.br/webhook/rest/acesso/numerodelicencas', this.body,httpOptions).subscribe(res => {

                        console.log("quantidade de cnpj's licenciado => " + parseInt(res.json()[0].quantidade));

                        if (parseInt(res.json()[0].quantidade) > 0) {
                            
                            this.global.setFullCompany(branchValid)
                            resolve(this.mensagem);

                        } else {

                            // this.storage.set('accessUser', undefined);

                            alertctrl.setSubTitle("Aplicativo não licenciado para o CNPJ " + branchValid.filial_cnpj + "!");
                            alertctrl.present();

                        }

                    }, (err) => {

                        console.log(err);

                        // this.storage.set('accessUser', undefined);
              
                        alertctrl.setSubTitle("Servidor de licença não encontrado, favor entrar em contato com o administrador do sistema!");
                        alertctrl.present();

                    });

                    */

                }

            }, err => {
                
                if (err.json().errorMessage) {
                    alertctrl.setSubTitle(err.json().errorMessage);
                    alertctrl.present();
                } else if (err.json().message) {
                    alertctrl.setSubTitle(err.json().message);
                    alertctrl.present();
                } else {
                    resolve(false);
                }
            })
        });
    }    
}



// WEBPACK FOOTER //
// ./src/providers/login-service.ts